import Vue from "vue";
import App from "./App.vue";
import store from "./store/store";
import vuetify from "./plugins/vuetify";
import router from "./router";
// import * as types from "./store/types.js";
import { ACTION_IS_LOGGED_IN } from "./store/constants/user";
import axios from "./services/axios.service";
// import firebase from "firebase/app";
import firebase from "firebase/app";
// import "firebase/auth";
import "firebase/firestore";
// import "firebase/functions";
// import "firebase/storage";
// import "firebase/messaging";
// import "firebase/database";

// import { initializeApp } from "firebase/app";

// const firebaseConfig = {
//   apiKey: "AIzaSyCuAwQexc73y64jNCwIgyzdQ8M6TVLqvTQ",
//   authDomain: "finrax-internal-dashboard.firebaseapp.com",
//   databaseURL: "https://finrax-internal-dashboard.firebaseio.com",
//   projectId: "finrax-internal-dashboard",
//   storageBucket: "finrax-internal-dashboard.appspot.com",
//   messagingSenderId: "588683530127",
//   appId: "1:588683530127:web:e41758ec0ffe6a55ca85fa",
//   measurementId: "G-CPCYYFLEF7"
// };

// firebase.initializeApp(firebaseConfig);

//Export to CSV
// import VuePapaParse from "vue-papa-parse";
// Vue.use(VuePapaParse);

//Moment.js
// var moment = require("moment");
// Vue.prototype.moment = moment;

//Services
import { TokenService } from "./services/storage.service";

if (TokenService.getConfig("email")) {
  store.dispatch(ACTION_IS_LOGGED_IN, true);
}

//Vue-scroll

// import vuescroll from "vuescroll/dist/vuescroll-native";
// import("vuescroll/dist/vuescroll.css");
// Vue.use(vuescroll);
// Vue.prototype.$vuescrollConfig = {
//   vuescroll: {
//     mode: "native",
//     // speedMultiplier:1,
//     // padding: false,
//     // detectResize: true
//     sizeStrategy: "100%",
//   },
//   bar: {
//     showDelay: 300,
//     onlyShowBarOnScroll: true,
//     keepShow: false,
//     background: "#c1c1c1",
//     opacity: 0.3,
//     hoverStyle: false,
//     specifyBorderRadius: false,
//     minSize: 0,
//     size: "4px",
//     disable: false,
//   },
//   rail: {
//     gutterOfSide: "0px",
//   },
//   scrollPanel: {
//     padding: false,
//     speed: 1000,
//     scrollingX: false,
//   },
//   scroller: {
//     bouncing: false,
//   },
// };

//VueClipboard
import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);

//VeeValidate
import VeeValidate from "vee-validate";
import { Validator } from "vee-validate";

const dictionary = {
  en: {
    custom: {
      loginEmail: {
        required: "Email is required",
        email: "Please enter a valid email address",
      },
      loginPass: {
        required: "Password is required",
      },
      url: {
        url: "Invalid URL",
      },
      emailUser: {
        required: "Email is required",
        email: "Please enter a valid email address",
      },
      userPassword: {
        required: "Password is required",
        regex: "At least one uppercase and number",
        min: "At least 8 characters",
      },
      oldPassword: {
        required: "Old password is required",
        regex: "At least one uppercase and number",
        min: "At least 8 characters",
      },
      confirmationPassword: {
        required: "Confirm Password is required",
        is: "Confirm Password doesn`t match",
      },
      "app-name": {
        required: "Name is required",
        regex: "Name should only contain letters,numbers and spaces",
      },
      orgName: {
        required: "Name is required",
        regex: "Name should only contain letters,numbers and spaces",
      },
      withdrawalCallback: {
        regex: "Invalid URL format",
      },
      depositCallback: {
        regex: "Invalid URL format",
      },
      depositCallback2: {
        regex: "Invalid URL format",
      },

      paymentID: {
        required: "ID is required",
      },
      amountInternal: {
        regex: "Value must be number",
        required: "Amount is required",
      },
      token: {
        required: "Token is required",
        numeric: "Only numbers allowed",
        length: "2FA must be 6 digits",
      },
      recepientAddress: {
        required: "Address is required",
      },
      amountFiаt: {
        required: "Amount is required",
        decimal: "Decimal signs exceeded",

        min_value: "Value can't be 0",
        regex: "Bigger than 0, two decimals max,no comma",
      },
      settlementAmount: {
        required: "Amount is required",
        decimal: "Decimal signs exceeded",

        min_value: "Min. value is 25000 EUR",
        regex: "Min. value is 25000 EUR, two decimals max,no comma",
      },
      fiatAllocation: {
        required: "Field is reqiured",
        numeric: "Only numbers",
        min_value: "Min value is 0",
        max_value: "Max value is 100",
      },
      crytoAllocation: {
        required: "Field is reqiured",
        numeric: "Only numbers",
        min_value: "Min value is 0",
        max_value: "Max value is 100",
      },
      amountCrypto: {
        required: "Amount is required",
        min_value: "Value can't be null",
        decimal: "Decimal signs exceeded",
        regex: "Bigger than 0, no comma",
      },
      expiration: {
        // min_value: 'Min. value 0',
        numeric: "Only numbers allowed",
      },
      destinationTag: {
        required: "If no Destination Tag or MemoID is needed, enter 0",
        numeric: "Only numbers",
      },
      amountDeposit: {
        decimal: "Only numeric, two decimals max",
        min_value: "Value can't be null",
      },
      authentication: {
        required: "Code is required",
        numeric: "Only numbers allowed",
        length: "2FA must be 6 digits",
      },
      twoFactor: {
        numeric: "Only numbers allowed",
        length: "2FA must be 6 digits",
        required: "Code is required",
      },
      keyName: {
        required: "API key name is required",
        regex: "Name should only contain letters,numbers and spaces",
      },
      ip: {
        required: "IP address is required",
        ip: "Must be valid IP address",
      },
    },
  },
};

Validator.localize(dictionary);
Vue.use(VeeValidate, {
  fieldsBagName: "vvFields",
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,

  render: (h) => h(App),
  created() {
    firebase.initializeApp({
    apiKey: "AIzaSyD_2lRMz6_KVZmSGapZfEtrKAJZK19kcwA",
    authDomain: "finrax-onboarding-dashboard.firebaseapp.com",
    projectId: "finrax-onboarding-dashboard",
    storageBucket: "finrax-onboarding-dashboard.appspot.com",
    messagingSenderId: "215216870615",
    appId: "1:215216870615:web:3582846efb3d32733a0c92"
    });
  },
}).$mount("#app");
